export const FREQUENCIE_ACTIVITIES_TYPES_INITIAL_FILTER = {
  has_activities_types: [],
  not_has_activities_types: [],
}
